<template>
  <div data-app class="md-card md-theme-default card" >
    <div class="md-layout input-layout panel">
      <validated-number-input
        class="md-layout-item"
        label="Amount"
        prefix="$"
        v-model="form.amount"
        type="CURRENCY"
        errormsg = "Please enter a valid amount. E.g: 5000, 5000.00" 
      />
      <validated-number-input
        class="md-layout-item md-size-100"
        label="Term"       
        suffix="Months" 
        v-model="form.term"    
        integer  
      />
      <validated-number-input
        class="md-layout-item md-size-100"
        label="Deposit"
        prefix="$"
        v-model="form.deposit"
        type="CURRENCY"
        errormsg = "Please enter a valid deposit. E.g: 50, 50.00"        
      />
      <validated-number-input
        class="md-layout-item md-size-100"
        label="Rate"
        prefix="%"
        v-model="form.rate"   
      />      
      <md-switch 
        class="md-layout-item md-size-100" 
        v-model="form.balloon_payment" 
      >Balloon Payment</md-switch>  
      <validated-number-input
        class="md-layout-item"
        label="Balloon Percent"
        v-if="form.balloon_payment"
        v-model ="form.balloon_percent"
        prefix="%"        
      />
      <validated-number-input
        class="md-layout-item"
        label="Ballon Amount"
        v-if="form.balloon_payment"
        v-model ="form.balloon_amount"
        prefix="$"    
      />
      <label class="md-layout-item labelFreq md-size-100">Frequency</label>
      <v-select 
        class="md-layout-item" 
        v-model="form.frequency"
        :items="frequencies"
        item-text="label"
        item-value="value"  
        dense
      />
      <md-card v-if="results">
        <md-card-header-text style="padding-top:10px">
          <div class="md-title">{{ results | currency }}</div>
          <div class="md-subhead">Per {{ freq }}</div>
          <div class="md-subhead">Interest from: {{ form.rate }}%</div>
        </md-card-header-text>
        <md-card-content>
          <p>Total repayments over {{ form.term }} months is {{ totalRepayments }}</p>
          <p v-if="form.balloon_payment">
            Risidual/balloon payment of {{ form.balloon_amount | currency }}
          </p>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>
import ValidatedInputs from "@/components/ValidatedInput";
import utils from "../components/utils/utils";
import filters from "../components/utils/filters";

export default {
  components: {
    ...ValidatedInputs,
  },
  data() {
    return {     
      frequencies: [
        { label: 'Weekly', value: 'Weekly' },
        { label: 'Fortnightly', value: 'Fortnightly' },
        { label: 'Monthly', value: 'Monthly' }
      ],
      results: null,
      lockWatcher: false,
      form: {
        amount: 50000,
        term: 60,
        deposit: 0,
        frequency: 'Weekly',
        payment_number: null,
        balloon_payment: false,
        balloon_percent: null,
        balloon_amount: null,
        rate: 7.5,
        monthly_account_fee: 0
      }     
    };
  },
  computed:{
    freq(){
      return {
        Weekly: "week",
        Fortnightly: "fortnight",
        Monthly: "month"
      }[this.form.frequency]
    },
    numberPayments(){
      return {
        Weekly: this.form.term * 4.333,
        Fortnightly: this.form.term * 2.167,
        Monthly: this.form.term
        }[this.form.frequency]
    },
    totalRepayments(){
      return this.currency(Math.round(this.numberPayments)*this.results)
    }
  },
  watch: {
    form: {
      deep: true,
      handler () {
        this.calculate()
      }
    },
    'form.balloon_percent' (val) {
      if (!this.watchLock()) {
        return
      }
      this.form.balloon_amount = val ? parseFloat(val) / 100 * this.form.amount.toString().replace(/,/g, '') : ''
    },
    'form.balloon_amount' (val) {
      if (!this.watchLock()) {
        return
      }
      this.form.balloon_percent = val ? (parseFloat(val) / parseFloat(this.form.amount.toString().replace(/,/g, '')) * 100) : ''
    }
  },
  mounted(){
    this.form.amount = 50000
    this.form.term = 60
    this.calculate()
  },
  methods: {
    watchLock () {
      return this.lockWatcher = !this.lockWatcher
    },
    calculate () {
      if (!this.form.amount) {
        return
      }
      this.results = utils.calculateRepayments(
        this.form.amount-this.form.deposit,
        this.form.rate,
        this.form.term,
        "Monthly",
        this.form.frequency,
        this.form.monthly_account_fee,
        this.form.balloon_amount
      )
    },
    ...filters,
  },
  filters: {
    ...filters,
  }
}
</script>
<style>
.card {
  width: 40%;
  margin: 40px 0 0 28vw !important;
}
.panel {
  padding: 20px !important;
}
.labelFreq{
  color:rgba(0, 0, 0, 0.54);
  font-size: 0.6875rem;
  font-weight: 400;
}

@media screen and (max-width: 768px) {
  .card {
    width: 100%;
    margin: 10px !important;
  }
}
</style>